export const currencyFields = [
  'cpc',
  'spend',
  'lifetimeBudget',
  'lifetimeSpend',
  'cppv',
  'pixelCostPerPageView',
  'remainingBudget',
  'pixelCostPerPageView',
  'revenue',
  'profit',
  'costPerVideoView',
  'videoP25CostPerWatchedAction',
  'videoP50CostPerWatchedAction',
  'videoP75CostPerWatchedAction',
  'videoP100CostPerWatchedAction',
  'videoThruplayCostPerWatchedAction'
];

export const percentFields = ['ctr', 'newReturningRatio', 'revenueRoi', 'revenueRoiGoal'];

export const currencyFormatter = (val: number | string, options?: { digits?: number }) =>
  val.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: options?.digits || 3
  });

export function truncateNumber(n: number, to?: number) {
  const [whole, fraction] = n.toString().split('.');
  if (!to) {
    return whole;
  }
  return to && to >= fraction.length ? `${n}` : `${whole}.${fraction.substring(0, to)}`;
}

export function roundNumeric(value: number) {
  if (value % 1 !== 0) {
    const stringified = value.toString();
    if (stringified.includes('.000')) {
      return value.toFixed();
    } else if (stringified.includes('.00') || stringified.indexOf('0.0') === 0) {
      return truncateNumber(value, 3);
    }
    return truncateNumber(value, 2);
  }
  return value.toString();
}

function processCtr(num: number) {
  return parseFloat(roundNumeric(num * 100)) + '%';
}

export function formatNumeric(value: number | string, key: string) {
  const prefix = '';
  let suffix = '';
  if (typeof value === 'number' && !isFinite(value)) {
    return '0';
  }
  let transformedValue = typeof value === 'number' ? parseFloat(roundNumeric(value)) : value;
  if (key === 'ctr') {
    return processCtr(value as number);
  }
  if (
    (key.includes('cost') || key.includes('totalValue') || currencyFields.includes(key)) &&
    typeof value === 'number'
  ) {
    return currencyFormatter(transformedValue);
  }
  if (key.includes('roas') || percentFields.includes(key)) {
    suffix = '%';
  }
  if (typeof value === 'number') {
    transformedValue = transformedValue.toLocaleString('en-US');
  }
  return `${prefix}${transformedValue}${suffix}`;
}

export const formatByKey = (key: string) => (value: number | string) => formatNumeric(value, key);
